class StoreLocator extends HTMLElement {
  constructor() {
    super();

    this.stores = window.stores;
    this.filteredStores = this.stores;

    this.main = this.querySelector(".store-locator__main");
    this.empty_state = this.querySelector(".store-locator__empty");

    this.currentPage = 1;
    this.itemsPerPage = 10;
    this.pagination = {
      el: this.querySelector(".store-locator__pagination"),
      prev: this.querySelector(".pagination__item--prev"),
      next: this.querySelector(".pagination__item--next"),
      list: this.querySelector(".pagination__list")
    };

    this.filters = this.querySelectorAll("[data-store-filter]");
  }

  connectedCallback() {
    this.render();

    this.filters.forEach(filter => {
      if (filter.type === "text") {
        let timeout;
        filter.addEventListener("input", () => {
          clearTimeout(timeout);
          timeout = setTimeout(() => {
            this.filter();
          }, 400);
        });
      } else {
        filter.addEventListener("change", this.filter.bind(this));
      }
    });

    if (window.innerWidth > 991) {
      this.querySelectorAll(".store-locator__sidebar details").forEach(details => details.toggleAttribute("open", true));
    }
  }

  filter() {
    const provinceFilters = Array.from(document.querySelectorAll('input[name="province-filter"]:checked')).map(input => input.value);
    const cityFilters = Array.from(document.querySelectorAll('input[name="city-filter"]:checked')).map(input => input.value);
    const suburbFilters = Array.from(document.querySelectorAll('input[name="suburb-filter"]:checked')).map(input => input.value);
    const brandFilters = Array.from(document.querySelectorAll('input[name="brand-filter"]:checked')).map(input => input.value);

    const searchInput = this.querySelector('input[type="text"][data-store-filter]');
    const searchTerm = searchInput ? searchInput.value.trim().toLowerCase() : "";

    const filteredStores = this.stores.filter(store => {
      const provinceFilter = provinceFilters.length === 0 || provinceFilters.includes(store.province);
      const cityFilter = cityFilters.length === 0 || cityFilters.includes(store.city);
      const suburbFilter = suburbFilters.length === 0 || suburbFilters.includes(store.suburb);
      const brandFilter = brandFilters.length === 0 || store.brands.some(brand => brandFilters.includes(brand));

      let searchFilter = true;
      if (searchTerm) {
        searchFilter =
          (store.name && store.name.toLowerCase().includes(searchTerm)) ||
          (store.province && store.province.toLowerCase().includes(searchTerm)) ||
          (store.city && store.city.toLowerCase().includes(searchTerm)) ||
          (store.suburb && store.suburb.toLowerCase().includes(searchTerm)) ||
          (store.brands && store.brands.some(brand => brand.toLowerCase().includes(searchTerm)));
      }

      return provinceFilter && cityFilter && suburbFilter && brandFilter && searchFilter;
    });

    if (JSON.stringify(filteredStores) === JSON.stringify(this.filteredStores)) return;

    this.filteredStores = filteredStores;

    const totalPages = Math.ceil(this.filteredStores.length / this.itemsPerPage);
    if (this.currentPage > totalPages) {
      this.currentPage = Math.max(1, totalPages);
    }

    this.render();
  }

  render() {
    this.renderStores();
    this.renderPagination();
  }

  renderStores() {
    const list = this.querySelector(".store-locator__list");
    list.innerHTML = "";

    const outputStores = this.filteredStores.slice((this.currentPage - 1) * this.itemsPerPage, this.currentPage * this.itemsPerPage);

    if (outputStores.length === 0) {
      this.main.classList.add("hidden");
      this.empty_state.classList.remove("hidden");
      return;
    } else {
      this.main.classList.remove("hidden");
      this.empty_state.classList.add("hidden");
    }

    outputStores.forEach((store, index) => {
      const item = document.createElement("li");
      item.classList.add("store-locator__item");
      item.innerHTML = `
      <div class="store-card" style="animation-delay: ${index * 0.1}s;">
        <div class="store-card__map">
          <iframe
            width="450"
            height="250"
            frameborder="0" style="border:0"
            referrerpolicy="no-referrer-when-downgrade"
            src="https://www.google.com/maps/embed/v1/place?key=AIzaSyBaqkK8qKB5usmwBAvdtij8pSn3F9ukyzA&q=${encodeURIComponent(store.name)},${encodeURIComponent(store.suburb)},${encodeURIComponent(store.city)},${encodeURIComponent(store.province)}"
            allowfullscreen>
          </iframe>
        </div>
        <div class="store-card__content">
          <h3 class="h5 store-card__title">${store.name}</h3>
          <p class="store-card__address">${store.address}</p>
          <div class="store-card__brands">
            ${store.brands.map(brand => `<span class="label uppercase">${brand}</span>`).join("")}
          </div>
        </div>
      </div>
      `;
      list.appendChild(item);
    });
  }

  renderPagination() {
    const totalPages = Math.ceil(this.filteredStores.length / this.itemsPerPage);

    if (totalPages <= 1) {
      this.pagination.el.style.display = "none";
      return;
    } else {
      this.pagination.el.style.display = "flex";
    }

    const newPrevButton = this.pagination.prev.cloneNode(true);
    this.pagination.prev.parentNode.replaceChild(newPrevButton, this.pagination.prev);
    this.pagination.prev = newPrevButton;

    const newNextButton = this.pagination.next.cloneNode(true);
    this.pagination.next.parentNode.replaceChild(newNextButton, this.pagination.next);
    this.pagination.next = newNextButton;

    this.pagination.list.innerHTML = "";

    // Add event listeners to the fresh buttons

    this.pagination.prev.disabled = this.currentPage === 1;
    this.pagination.prev.addEventListener("click", () => {
      if (this.currentPage > 1) {
        this.currentPage--;
        this.render();
      }
    });

    this.pagination.next.disabled = this.currentPage === totalPages;
    this.pagination.next.addEventListener("click", () => {
      if (this.currentPage < totalPages) {
        this.currentPage++;
        this.render();
      }
    });

    const displayRange = 2;
    let startPage = Math.max(1, this.currentPage - displayRange);
    let endPage = Math.min(totalPages, this.currentPage + displayRange);

    if (endPage - startPage < 4 && totalPages > 4) {
      if (this.currentPage < totalPages / 2) {
        endPage = Math.min(totalPages, startPage + 4);
      } else {
        startPage = Math.max(1, endPage - 4);
      }
    }

    if (startPage > 1) {
      const firstPageItem = document.createElement("li");
      firstPageItem.innerHTML = `<button class="pagination__item ${this.currentPage === 1 ? "pagination__item--current" : ""}">1</button>`;
      firstPageItem.addEventListener("click", () => {
        this.currentPage = 1;
        this.render();
      });
      this.pagination.list.appendChild(firstPageItem);

      if (startPage > 2) {
        const ellipsisItem = document.createElement("li");
        ellipsisItem.innerHTML = `<span class="pagination__ellipsis">&hellip;</span>`;
        this.pagination.list.appendChild(ellipsisItem);
      }
    }

    for (let i = startPage; i <= endPage; i++) {
      if ((i === 1 && startPage > 1) || (i === totalPages && endPage < totalPages)) continue;

      const item = document.createElement("li");
      item.innerHTML = `<button class="pagination__item ${this.currentPage === i ? "pagination__item--current" : ""}">${i}</button>`;

      item.addEventListener("click", () => {
        this.currentPage = i;
        this.render();
      });
      this.pagination.list.appendChild(item);
    }

    if (endPage < totalPages) {
      if (endPage < totalPages - 1) {
        const ellipsisItem = document.createElement("li");
        ellipsisItem.innerHTML = `<span class="pagination__ellipsis">&hellip;</span>`;
        this.pagination.list.appendChild(ellipsisItem);
      }

      const lastPageItem = document.createElement("li");
      lastPageItem.innerHTML = `<button class="pagination__item ${this.currentPage === totalPages ? "pagination__item--current" : ""}">${totalPages}</button>`;
      lastPageItem.addEventListener("click", () => {
        this.currentPage = totalPages;
        this.render();
      });
      this.pagination.list.appendChild(lastPageItem);
    }
  }
}
if (!customElements.get("store-locator")) {
  customElements.define("store-locator", StoreLocator);
}
